import React, { useContext } from 'react';
import { isLocked, useIsEntitledQuery, useCachedProgressItemQuery, } from '@annunciate/query';
import { Card } from '../../shared';
import { getProgressPercent } from '../../../utils/progress';
import { NavigationContext, View } from '../../..';
export const UnmemoizedCarouselSlide = ({ index, item: defaultItem, isLoading = false, padLeft = true, padRight = true, heightConstraint, }) => {
    const item = defaultItem &&
        defaultItem.id !== undefined &&
        defaultItem.id >= 0
        ? defaultItem : undefined;
    const { onNavigateToItem: onPress } = useContext(NavigationContext);
    const { data } = useCachedProgressItemQuery(item?.id);
    const isEntitled = useIsEntitledQuery(item);
    const isLoadingState = !item || isLoading === true;
    const type = item?.__typename || '';
    const DefaultComponent = React.createElement(View, { style: { minHeight: heightConstraint + 30 } });
    if (['Content', 'Collection'].includes(type) || isLoadingState === true) {
        const uri = item?.cover?.src;
        let progress = 0;
        if (data && type === 'Content') {
            progress = getProgressPercent(data);
        }
        return React.createElement(Card, { index: index, item: item, downloadId: item?.id, uri: uri, title: item?.name, description: item?.description, padLeft: padLeft, padRight: padRight, onPress: () => onPress && item && onPress(item), isLocked: isLocked({ isEntitled, item }), isLoading: isLoadingState, heightConstraint: heightConstraint, progress: progress });
    }
    return DefaultComponent;
};
export const CarouselSlide = React.memo(UnmemoizedCarouselSlide, ({ item: prevItem, index: prevIdx, isLoading: prevIsLoading }, { item: nextItem, index: nextIdx, isLoading: nextIsLoading }) => {
    const isLoading = (prevIsLoading && nextIsLoading) ||
        (prevItem === undefined && nextItem === undefined);
    const isItemIdIdentical = prevItem?.id === nextItem?.id;
    return isLoading || (isItemIdIdentical &&
        prevIdx === nextIdx);
});
//# sourceMappingURL=CarouselSlide.js.map